import { connect } from 'react-redux';
import {getTranslation} from "../../../reducers/common/localization";
import AccreditationRequestsByDomainsList, {AVAILABLE_LIST_TYPES} from "./AccreditationRequestsByDomainsList";
import {
    MODAL_EDIT_ACCREDITATION_REQUESTS_BY_DOMAIN, MODAL_REMOVE_ACCREDITATION_REQUESTS_BY_DOMAIN,
    MODAL_LAST_REQUESTORS_ACCREDITATION_REQUEST_BY_DOMAIN,
    showModal, MODAL_VALIDATE_DOMAIN
} from '../../../reducers/common/activeModal';
import {
    getUnreferencedAccreditationRequestsData,
    loadingUnreferencedAccreditationRequests, onGetAccreditationRequestsByDomains,
    onGetAccreditationRequestsFilteredByDomains, resetAccreditationRequestsData, setFilterDomain, setValidated,
    fetchGetLastRequestorsOfAccreditationRequest
} from "../../../reducers/accreditation/unreferencedAccreditationRequests";
import {resetSubmitFormData} from "../../../reducers/common/submitForm";

const mapStateToProps = state => {
    return {
        loading: loadingUnreferencedAccreditationRequests(state),
        translation: getTranslation(state),
        data: getUnreferencedAccreditationRequestsData(state),
        listType: AVAILABLE_LIST_TYPES.PENDING
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onMount: () => {
            dispatch(setFilterDomain(null));
            dispatch(setValidated(false));
            dispatch(onGetAccreditationRequestsByDomains());
        },
        onAccreditationRequestsByDomainRemove: () => {
            dispatch(resetSubmitFormData());
            dispatch(showModal({modalKey: MODAL_REMOVE_ACCREDITATION_REQUESTS_BY_DOMAIN}))
        },
        onAccreditationRequestsByDomainEdit: () => {
            dispatch(resetSubmitFormData());
            dispatch(showModal({modalKey: MODAL_EDIT_ACCREDITATION_REQUESTS_BY_DOMAIN}))
        },
        onAccreditationRequestsByDomainValidate: () => {
            dispatch(resetSubmitFormData());
            dispatch(showModal({modalKey: MODAL_VALIDATE_DOMAIN}))
        },
        onFilterByDomain: (domain) => {
            dispatch(onGetAccreditationRequestsFilteredByDomains(domain));
        },
        onUnmount: () => {
            dispatch(resetAccreditationRequestsData());
        },
        onShowLastRequestors: (domain) => {
            dispatch(fetchGetLastRequestorsOfAccreditationRequest(domain));
            dispatch(showModal({modalKey: MODAL_LAST_REQUESTORS_ACCREDITATION_REQUEST_BY_DOMAIN}));
        }
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(AccreditationRequestsByDomainsList);



// WEBPACK FOOTER //
// ./src/components/accreditationManagement/accreditationRequestsByDomainsList/PendingAccreditationRequestsByDomainsList.container.js